import paymentCheckModule from "@/services/payment/payment_check/index";
import { PaymentWithSituationParams } from "@/services/offer/offer_handle";

export const payByAny = async (payload: PaymentWithSituationParams) => {
  paymentCheckModule.init(payload);
  paymentCheckModule.get().next();
};
